var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReceipe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5222",
    "data-name": "Group 5222",
    transform: "translate(-10 -532)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1348",
    "data-name": "Rectangle 1348",
    width: 81,
    height: 81,
    rx: 40.5,
    transform: "translate(10 532)",
    fill: "#1e222f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Recipe-1",
    transform: "translate(21.299 532.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M12.7,16.8H45.676V61.651H12.7V16.8Zm2.275,2.139V50.454H43.443V18.939Zm17.657,35.8v2.3H14.975v2.5H43.443V52.865H14.975v1.889l17.657-.01Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    d: "M82.528,102.276H77.414c-.814,0-1.148-.324-1.148-1.117,0-2.191-.01-4.383.01-6.574a.51.51,0,0,0-.4-.574,5.458,5.458,0,0,1-3.548-5.771,5.518,5.518,0,0,1,5.2-4.79.826.826,0,0,0,.678-.344,5.564,5.564,0,0,1,8.766.01.772.772,0,0,0,.637.323A5.537,5.537,0,0,1,92.8,87.969a5.43,5.43,0,0,1-3.527,6.042.475.475,0,0,0-.365.553q.016,3.24.01,6.48c0,.929-.313,1.231-1.242,1.231Zm4.362-5.833v-2.8c0-.866.219-1.137,1.064-1.3a3.5,3.5,0,0,0-.918-6.929,1.33,1.33,0,0,1-1.409-.741,3.547,3.547,0,0,0-6.5.96,3.515,3.515,0,1,0-1.962,6.71c.887.188,1.085.428,1.085,1.336v2.776l8.64-.01ZM78.28,98.457V100.3h8.578V98.457Z",
    transform: "translate(-53.361 -57.478)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipe);
export default __webpack_public_path__ + "static/media/receipe.4290da443da60d704694d101f97a0aa6.svg";
export { ForwardRef as ReactComponent };